<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Diamond Transactions</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <a class="com_btn" (click)="vip_sub_transactions('3')"
                >Transactions</a
              >
              <a class="com_btn" (click)="vip_sub_transactions('4')"
                >Deductions</a
              >
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <table class="table" *ngIf="tab_type == 3 || tab_type == 4">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Type</th>
                    <th scope="col">Customer Email</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of transactions; let a = index">
                    <th scope="row">{{ transactions.length - a }}</th>
                    <td>
                      <span *ngIf="i.typeis == 1">Add</span>
                      <span *ngIf="i.typeis == 0">Deduct</span>
                    </td>

                    <td>{{ i.email }}</td>
                    <td>$ {{ i.price }}</td>
                    <td>{{ i.created * 1000 | date : "mediumDate" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
